import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name.split(" ")[0]}.`);
      const next = location.state?.from || (user.role === "admin" ? "/admin" : "/account");
      navigate(next);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  const googleSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="bg-[#FFF4E0] min-h-[80vh] grid grid-cols-1 lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1668815142412-c912ff69ae15?w=1200" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#831132]/40 to-transparent" />
        <div className="absolute bottom-10 left-10 text-[#FFF4E0]">
          <div className="overline text-[#FFF4E0]/80">The House</div>
          <div className="font-serif-display text-4xl mt-2">Crown yourself.</div>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-20">
        <div className="w-full max-w-md">
          <div className="overline mb-3">Members</div>
          <h1 className="font-serif-display text-5xl text-[#1A0F11]">Sign in</h1>
          <p className="text-sm text-[#5C4A4D] mt-3">Welcome back to the house.</p>
          <form onSubmit={submit} className="mt-10 space-y-6">
            <div>
              <div className="label-luxe">Email</div>
              <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-luxe" data-testid="login-email" />
            </div>
            <div>
              <div className="label-luxe">Password</div>
              <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-luxe" data-testid="login-password" />
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>
          <div className="my-8 flex items-center gap-4 text-xs text-[#5C4A4D] uppercase tracking-[0.22em]">
            <div className="flex-1 h-px bg-[#E8D8C8]" /> or <div className="flex-1 h-px bg-[#E8D8C8]" />
          </div>
          <button onClick={googleSignIn} className="btn-outline w-full" data-testid="google-signin">
            Continue with Google
          </button>
          <p className="text-sm text-[#5C4A4D] mt-8 text-center">
            New here? <Link to="/register" className="text-[#831132] hover:underline" data-testid="login-register-link">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
